import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
    spacer: {
        marginTop: 7,
        marginBottom: 7,
        width: '100%'
    }
}));
